module.exports = __webpack_public_path__ + "Roboto-LightItalic.879d940bccbb25f6096e.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-LightItalic.woff2
// module id = 314
// module chunks = 19